<template>
  <div id="modal_popup_game" class="modal-popup">
    <div class="modal-popup-content">
      <a @click="showModalPopup('modal_popup_game', false)" class="close-button">
        <img src="@/assets/images/cms-mkt/close-button.svg" />
      </a>
      <!-- <div class="d-inline-block container-right"> -->
      <div class="offer-details-wrapper">
        <div class="addRewardLayout border-box flex-wrap flex-xl-nowrap justify-content-center">
          <div class="container-fluid d-flex flex-column align-items-center">
            <div class="row d-flex flex-column align-items-baseline w-80 ">
              <small class="text-break">{{ $t("cmsLang.gameNameRoLabel") }}</small>
              <input type="text" required v-model="newGame.texts['ro'].title" class="formedituser w-100" />
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80 ">
              <small class="text-break">{{ $t("cmsLang.gameNameEnLabel") }}</small>
              <input type="text" required v-model="newGame.texts['en'].title" class="formedituser w-100" />
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.gameDescriptionRoLabel") }}</small>
              <textarea required v-model="newGame.texts['ro'].description" class="formedituser w-100" maxlength="500" />
              <!-- <VueEditor id="editor" v-model="newGame.texts['ro'].description" :editor-toolbar="customToolbar"
                class="formedituser w-100" maxlength="500" /> -->
              <!-- <textarea v-model="newGame.texts['ro'].description" class="formedituser w-100" maxlength="500" /> -->
            </div>
            <br />

            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.gameDescriptionEnLabel") }}</small>
              <textarea required v-model="newGame.texts['en'].description" class="formedituser w-100" maxlength="500" />
              <!-- <VueEditor id="editor" v-model="newGame.texts['en'].description" :editor-toolbar="customToolbar"
                class="formedituser w-100" maxlength="500" /> -->
              <!-- <textarea v-model="newGame.texts['en'].description" class="formedituser w-100" maxlength="500" /> -->
            </div>
            <br />
            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.rewardLabel") }}</small>
              <input type="number" v-model="newGame.upCoins" class="formedituser w-100" onwheel="return false;"/>
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.categoryLabel") }}</small>
              <!-- <input type="text" v-model="newGame.category" class="formedituser w-100" /> -->
              <div class="radioButtonCustom">
                <label v-for="(category, index) in categoriesSelect" :key="index">
                  <input name="categorytype" type="radio" :value="category"
                    @change="selectNewGameCategory($event.target, category)"
                    :checked="category.category_name === newGame.category.category_name">
                  {{ category.category_name }}</label>
              </div>
              <!-- <multiselect v-model="newGame.category" :options="categoriesSelect" class="margin-top-1rem" -->
              <!-- :placeholder="$t('cmsLang.selectLabel')" select-label="" selected-label="" deselect-label="" /> -->
            </div>
            <div class="row d-flex flex-column  align-items-baseline w-80">
              <p v-html="$t('cmsLang.categoryWarning')" class="orange"></p>
              <small class="text-break">{{ $t("cmsLang.subcategoryLabel") }}</small>
              <multiselect v-model="newGame.subcategory" :options="subCategoriesSelect" class="margin-top-1rem"
                :placeholder="$t('cmsLang.selectLabel')" select-label="" selected-label="" label="subcategory_name"
                @select="selectNewGameSubcategory($event)" deselect-label="" track-by="category_id" />
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.durationLabel") }}</small>
              <div class=" d-flex flex-row justify-content-between w-80">
                <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                  :time="newGame.startDate" @close="startDateSelected" />
                <date-range class="invoices-filter" :noRanges="true" :single="true" :minDateOrder="minDate"
                  :time="newGame.endDate" @close="endDateSelected" />
              </div>
              <p v-html="$t('cmsLang.gameDateError')" class="red" v-if="this.dateError"></p>
              <p v-else></p>
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.imageLabel") }}</small>
              <p v-html="$t('cmsLang.imageWarning')" class="orange"></p>
              <div class="uploadImageDiv w-100">
                <div  @click="$refs.fileInput1.click()">
                  <div v-if="this.previewImage " class="offer-preview-image"
                    :style="{ 'background-image': `url(${previewImage})` }">
                  </div>
                  <div v-else-if="newGame.id > 0" class="offer-preview-image  w-100"
                    :style="{ 'background-image': `url(${this.gameImage()})` }">
                  </div>
                </div>
                <br />
                <p v-html="$t('cmsLang.imageInfoLabel')"  @click="$refs.fileInput1.click()">
                </p>
                <div v-if="this.imageError">
                  <p v-for="(entry, index) in this.imageError" :key="index" class="red">{{ entry.description ?
                    entry.error_code + " : " +
                    entry.description : $t('cmsLang.errorMessage_' + entry) }}</p>
                </div>
                <!-- <p v-html="$t('cmsLang.imageError')" class="red" v-if="this.imageError"></p> -->
                <p v-else></p>
                <!-- <a @click="$refs.fileInput1.click()" class="uploadFile">
                  {{ $t("cmsLang.uploadImageLabel") }}</a> -->
                <input type="file" @change="uploadFile()" ref="fileInput1" style="display: none"
                  accept=".png, .jpg, .jpeg" />
                <div class="w-100 text-left">
                  <a @click="resetImage" class="status-background background-will-expire color-darkgrey">Reset</a>
                </div>
              </div>
            </div>
            <br />
            <div v-if="this.isGameCommercial" class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.productLabel") }}</small>
              <!-- <input type="text" v-model="newGame.category" class="formedituser w-100" /> -->
              <div class="radioButtonCustom">
                <label v-for="(product, index) in products" :key="index">
                  <input name="producttype" type="radio" :value="product"
                    @change="selectNewGameProduct($event.target, product)" :checked="product === newGame.product">
                  {{ $t('cmsLang.product_' + product) }}</label>
              </div>
              <!-- <multiselect v-model="newGame.category" :options="categoriesSelect" class="margin-top-1rem" -->
              <!-- :placeholder="$t('cmsLang.selectLabel')" select-label="" selected-label="" deselect-label="" /> -->
            </div>
            <div v-if="isGameCommercial" class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.gameTypeComercialLabel") }}</small>
              <div>
                <div class="custom-control custom-switch">
                  <span><input type="checkbox" class="custom-control-input" id="customSwitchN" v-model="isAmount" />
                    <label class="custom-control-label" for="customSwitchN"></label>
                  </span>
                  <span>counter/amount</span>

                </div>
              </div>
            </div>
            <div v-if="this.isGameCommercial" class="row d-flex flex-column align-items-baseline w-80">
              <br />
              <small class="text-break">{{ $t(isAmount ? "missionTargetAmountLabel" : "missionTargetCountLabel")
              }}</small>
              <input type="number" v-model="newGame.valueToComplete" class="formedituser w-100" onwheel="return false;"/>
            </div>

            <div v-if="this.isGameCommercial" class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.missionMinTransactionValueLabel") }}</small>
              <input type="number" v-model="newGame.minTransactionValue" class="formedituser w-100" onwheel="return false;" />
            </div>
            <div v-if="this.isGameCommercial" class="row d-flex flex-column align-items-baseline w-80 border-round-white">
              <br />

              <small class="text-break">{{ $t("cmsLang.partnerTargetLabel") }}</small>
              <p v-html="$t('cmsLang.searchPartnerWarning')" class="orange"></p>
              <input type="number" :placeholder="$t('cmsLang.partnerCodeTargetLabel')" v-model="affiliatesFilter.code"
                class="formedituser w-100" v-on:keyup.enter="getAffiliates()" />
              <input type="text" :placeholder="$t('cmsLang.partnerFiscalTargetLabel')" v-model="affiliatesFilter.fiscalCode"
                class="formedituser w-100" v-on:keyup.enter="getAffiliates()" />
              <span>
                <a class="button-all button-white" @click="getAffiliates()"> {{ $t('cmsLang.searchLabel') }}</a>
                &nbsp;
                <input type="checkbox" @change="selectAllAffiliates" />
                {{ $t("cmsLang.partnerSelectAllLabel") }}
              </span>
              <br />
              <multiselect v-model="newGame.affiliates" :options="affiliates" :placeholder="$t('cmsLang.selectLabel')"
                select-label="" selected-label="" deselect-label="" :multiple=true openDirection="bottom"
                track-by="aff_code" :custom-label="customLabelAffiliate" :loading="isLoading" :limit=1></multiselect>
              <br />
              <br />

            </div>
            <!-- <div v-if="this.isGameMarketing" class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.gamePlatformLabel") }}</small>
              <input type="text" v-model="newGame.platform" class="formedituser w-100" />
            </div> -->
            <div v-if="this.isGameMarketing" class="row d-flex flex-column align-items-baseline w-80">
              <small class="text-break">{{ $t("cmsLang.gameUrlLabel") }}</small>
              <input type="text" v-model="newGame.url" class="formedituser w-100" />
            </div>
            <div v-if="this.error" class="row d-flex flex-column align-items-baseline w-80">
              <br />
              <p class="red">{{ $t('cmsLang.errorMessage_' + error.code) }}</p>
            </div>
            <div class="row d-flex flex-column align-items-baseline w-80">
              <br />
              <small class="text-break">{{ $t("cmsLang.publishLabel") }}</small>
              <div class="row d-flex flex-row align-items-baseline justify-content-between w-80">
                <a @click="submitGame(false)" class="button-all button-blue">
                  {{ $t('cmsLang.saveLabel') }}

                </a>
                <a @click="showModalPopup('modal_popup_confirm_approve', true)" class="button-all button-yellow" v-if="isUserAdmin(user)">
                  {{ $t('cmsLang.approveLabel') }}

                </a>
                <a @click="showModalPopup('modal_popup_confirm', true)" class="button-all button-red">
                  {{ $t('cmsLang.deleteLabel') }}

                </a>
              </div>
            </div>
          </div>
        </div>


      </div>
      <!-- </div> -->
    </div>
    <div id="modal_popup_confirm" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_confirm', false)" class="close-button">
          <img src="@/assets/images/cms-mkt/close-button.svg" />
        </a>
        <br />
        <p>
          {{ $t("cmsLang.confirmDeleteGameMessage") }}
        </p>
        <div class="buttons">
          <a href="#" class="yesButton" @click="deleteGame()">
            {{ $t("cmsLang.notificationsChooseOptionYes") }}
          </a>
          <a href="#" class="noButton" @click="showModalPopup('modal_popup_confirm', false)">
            {{ $t("cmsLang.notificationsChooseOptionNo") }}
          </a>
        </div>
      </div>
    </div>
    <div id="modal_popup_confirm_approve" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_confirm_approve', false)" class="close-button">
          <img src="@/assets/images/cms-mkt/close-button.svg" />
        </a>
        <br />
        <p v-html="$t('cmsLang.confirmApproveGameMessage', {start_date: displayDateFormat(newGame.startDate[0])})">
        </p>
        <div class="buttons">
          <a href="#" class="yesButton button-all button-yellow" @click="submitGame(true)">
            {{ $t("cmsLang.approveLabel") }}
          </a>
          <a href="#" class="noButton button-all button-red" @click="showModalPopup('modal_popup_confirm_approve', false)">
            {{ $t("cmsLang.cancelChangesLabel") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
// import validator from "@/plugins/fieldValidation";
import DateRange from "@/components/DateRange.vue";
// import { VueEditor } from "vue2-editor";
import httpServiceCustomer from "@/http/http-play.js";
import Cookies from "js-cookie";

export default {
  name: "NewGamePopup",

  props: {
    user: Object,
    game: Object,
    image: String,
    categories: Array
  },
  components: {
    DateRange,
    // VueEditor
  },
  data() {
    return {
      customToolbar: [
        [{ 'header': [false, 1, 2, 3, 4, 5, 6,] }],
        ["bold", "italic"],
        [{ align: "left" }, { align: "center" }, { align: "right" }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"]
      ],
      selectedCategory: false,
      newGame: {
        texts: [],
        upCoins: 0,
        category: "",
        subcategory: 0,
        startDate: [],
        endDate: [],
        image: null,
        groupMission: false,
        groupParticipants: 0,
        valueToComplete: 1,
        type: "amount",
        url: "",
        platform: "",
        product: 11,
        affiliates: [],

        // checkpoints: [
        //   {
        //     "type": "amount",
        //     "value_to_complete": 300,
        //     "up_coins": 20
        //   },
        //   {
        //     "type": "amount",
        //     "value_to_complete": 300,
        //     "up_coins": 20
        //   },
        //   {
        //     "type": "amount",
        //     "value_to_complete": 300,
        //     "up_coins": 20
        //   }
        // ]
      },
      affiliates: [],

      isAmount: false,
      previewImage: null,
      minDate: moment().toDate(),
      // products: [11, 12, 13, 14, 15],
      products: [11],
      dateError: false,
      imageError: null,
      error: null,
      affiliatesFilter: {
        code: "",
        fiscalCode: "",
      },
      isLoading: false,
      isSelectedAllAffiliates: false
    };
  },
  methods: {
    selectNewGameCategory(element, entry) {
      this.newGame.category = entry;
      this.newGame.type = this.newGame.category.mission_type;
      this.selectedCategory = true;
      this.affiliates = []
      this.newGame.affiliates = [];
      this.isSelectedAllAffiliates = false;
    },
    selectNewGameSubcategory(element) {
      this.newGame.subcategory = element;
      this.newGame.affiliates = [];
      this.affiliates = [];
      this.getAffiliates();
    },
    selectNewGameProduct(element, product) {
      this.newGame.product = product;
    },
    selectAllAffiliates() {
      this.isSelectedAllAffiliates = !this.isSelectedAllAffiliates;
      if (this.isSelectedAllAffiliates) {
        this.newGame.affiliates = this.affiliates;
      } else {
        this.newGame.affiliates = [];
      }
    },
    displayDateFormat(dateUnformatted){
      return moment(dateUnformatted).format('DD-MM-YYYY');
    },
    submitGame(approve) {
      // validare ??
      // construct game object

      this.error = null;

      if (this.newGame.category === "") {
        this.error = { code: "CATEGORY" };
        this.showModalPopup('modal_popup_confirm_approve', false);
        return;
      }
      if (this.newGame.texts.length = 0) {
        this.error = { code: "MI2" };
        this.showModalPopup('modal_popup_confirm_approve', false);
        return;
      }
      if (this.newGame.texts['ro'].title === "") {
        this.showModalPopup('modal_popup_confirm_approve', false);
        this.error = { code: "MI3" };
        return;
      }
      if (this.newGame.texts['ro'].description === "") {
        this.showModalPopup('modal_popup_confirm_approve', false);
        this.error = { code: "MI6" };
        return;
      }
      if (this.newGame.texts['en'].title === "") {
        this.showModalPopup('modal_popup_confirm_approve', false);
        this.error = { code: "MI5" };
        return;
      }
      if (this.newGame.texts['en'].description === "") {
        this.showModalPopup('modal_popup_confirm_approve', false);
        this.error = { code: "MI7" };
        return;
      }

      if (this.imageError != null){
        this.showModalPopup('modal_popup_confirm_approve', false);
        this.error = {code: "MI16"}
        return; 
      }

      this.showModalPopup("modal_popup_loading_cms", true);


      let submitGame = {
        mission_id: this.newGame.id,
        texts: [
          {
            type: this.textType,
            language: "ro",
            title: this.newGame.texts['ro'].title,
            description: this.newGame.texts['ro'].description
          },
          {
            type: this.textType,
            language: "en",
            title: this.newGame.texts['en'].title,
            description: this.newGame.texts['en'].description
          },
        ],
        up_coins: this.newGame.upCoins,
        type: this.newGame.type
      }

      submitGame.category = this.newGame.category.category_name;
      if (this.newGame.subcategory) {
        submitGame.category_id = this.newGame.subcategory.category_id;
      }
      if (this.newGame.endDate.length > 0) {
        submitGame.end_date = moment(this.newGame.endDate[0]).format('DD-MM-YYYY');
      }
      if (this.newGame.startDate.length > 0) {
        submitGame.start_date = moment(this.newGame.startDate[0]).format('DD-MM-YYYY');
      }
      submitGame.group_mission = this.newGame.groupMission ? 'Y' : 'N';
      submitGame.status = this.newGame.status;
      if (this.newGame.product > 0) {
        submitGame.product_code = this.newGame.product;
      }
      if (this.newGame.groupMission) {
        submitGame.targeted_group_company = this.newGame.targetedGroupCompany;
        submitGame.group_participants = this.newGame.groupParticipants
      }
      if (this.isGameCommercial) {
        submitGame.value_to_complete = this.newGame.valueToComplete;
        submitGame.min_transaction_value = this.newGame.minTransactionValue;
        if (this.newGame.affiliates && this.newGame.affiliates.length > 0) {
          submitGame.affiliates = this.newGame.affiliates;
        }
        submitGame.type = this.isAmount ? "amount" : "counter";

      }
      if (this.isGameMarketing) {
        submitGame.value_to_complete = 1;
        submitGame.url = this.newGame.url;
        submitGame.platform = this.newGame.platform;
      }

      if (this.newGame.checkpoints && this.newGame.checkpoints.size > 0) {
        submitGame.checkpoints = this.newGame.checkpoints;
      }

      if (this.newGame.image && !this.imageError) {
        submitGame.image = this.newGame.image;
      }

      if (approve) {
        this.approveGame(submitGame);
      } else if (this.newGame.id > 0) {
        this.updateGame(submitGame);
      } else {
        this.addNewGame(submitGame);
      }
    },
    approveGame(game) {
      httpServiceCustomer.customerService
        .approveGame(
          game,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$emit("showinfo", "gameApprovedSuccess", null);
            this.$emit("updatelist");

          } else {
            this.error = error.response.data;
            this.$emit("showinfo", "gameApprovedSuccess", this.error);
          }
          this.showModalPopup("modal_popup_loading_cms", false);

        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data;
          } else {
            this.error = ["undefined"];
          }
          this.$emit("showinfo", "", this.error);
          this.showModalPopup("modal_popup_loading_cms", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    updateGame(game) {
      httpServiceCustomer.customerService
        .updateGame(
          game,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$emit("showinfo", "gameModifiedSuccess", null);
            this.$emit("updatelist");

          } else {
            this.error = { code: response.status };
            this.$emit("showinfo", "", this.error);
          }
          this.showModalPopup("modal_popup_loading_cms", false);
          // this.showModalPopup("modal_popup_info", true);
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data;
          } else {
            this.error = ["undefined"];
          }
          // this.showModalPopup("modal_popup_loading_cms", false);
          this.showModalPopup("modal_popup_info", true);
          this.$emit("showinfo", "", this.error);
        });
    },
    addNewGame(game) {
      httpServiceCustomer.customerService
        .addNewGame(
          game,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$emit("showinfo", "gameAddSuccess", null);
            this.$emit("updatelist");

          } else {

            this.error = { code: response.status };
            this.$emit("showinfo", "", this.error);
          }
          this.showModalPopup("modal_popup_loading_cms", false);
          // this.showModalPopup("modal_popup_info", true);
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data;
          } else {
            this.error = ["undefined"];
          }
          this.showModalPopup("modal_popup_loading_cms", false);
          this.$emit("showinfo", "", this.error);
          // this.showModalPopup("modal_popup_info", true);
        });
    },
    deleteGame() {
      this.successMessage = "";
      this.error = null;
      this.showModalPopup("modal_popup_confirm", false);
      this.showModalPopup("modal_popup_loading_cms", true);

      httpServiceCustomer.customerService
        .deleteGame(
          this.newGame.id,
          Cookies.get("token")
        )
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            this.$emit("showinfo", "gameDeleteSuccess", null);
            this.$emit("updatelist");
          } else {
            this.error = { code: response.status };
          }
          this.showModalPopup("modal_popup_loading_cms", false);
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data;
          } else {
            this.error = ["undefined"];
          }
          this.showModalPopup("modal_popup_loading_cms", false);
          this.$emit("showinfo", "", error);
        });
    },
    uploadFile() {
      this.imageError = null;
      this.newGame.image = null;
      this.previewImage = null;
      let input = this.$refs.fileInput1;

      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        
        reader.readAsDataURL(file[0]);
        if (reader.readAsBinaryString) {
          console.log("read as binary string");
        } else {
          alert("This browser does not support HTML5.");
        }
        
        let fileType = file[0].type;
        if (!fileType.includes('jpeg') && !fileType.includes('jpg') && !fileType.includes('png')) {
          this.imageError = ["MA10"];
          return;
        }
        if (file[0].size > 256 * 1024 ) {
          this.imageError = ["MA11"];
          return;
        }

        let readerReward = new FileReader();
        readerReward.onload = (e) => {
          if (!e) {
            this.newGame.image = btoa(readerReward.content);
          } else {
            this.newGame.image = btoa(e.target.result);
          }
          this.validateFile();
        };
        // reader.readAsDataURL(file[0]);
        if (readerReward.readAsBinaryString) {
          readerReward.readAsBinaryString(file[0]);
        } else {
          alert("This browser does not support HTML5.");
        }
        

      }
    },
    validateFile() {
      if (this.newGame.image) {
        httpServiceCustomer.customerService
          .validateImage({content : this.newGame.image}, Cookies.get("token"))
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200) {
            } else {
              this.imageError = response.data;
            }

          });
      }
    },
    resetImage() {
      this.$refs.fileInput1.value = null;
      this.newGame.image = null;
      this.previewImage = null;
      this.imageError = null;
      this.error = null;
    },
    customLabelAffiliate({ aff_code, address, county }) {
      return `${aff_code} – ${county}, ${address}`;
    },
    getAffiliates() {
      this.affiliates = [];
      this.isSelectedAllAffiliates = false;
      // @queryParam name = search by name
      if (!this.newGame.subcategory) {
        return;
      }

      var affiliatesSearchData = "?";
      if (this.newGame.product > 0) {
        affiliatesSearchData += "&product=" + this.newGame.product;
      }
      if (this.affiliatesFilter.code.length > 0) {
        affiliatesSearchData += "&code=" + this.affiliatesFilter.code;
      }
      if (this.affiliatesFilter.fiscalCode.length > 0) {
        affiliatesSearchData += "&tax_number=" + this.affiliatesFilter.fiscalCode;
      }
      this.isLoading = true;
      affiliatesSearchData +=
        "&per_page=1000" +
        "&page=1";

      httpServiceCustomer.customerService
        .getAffiliates(this.newGame.subcategory.category_id, affiliatesSearchData, Cookies.get("token"))
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          // this.error = {
          //   code: error.response.data,
          //   description: error.response.data,
          // };
          return error.response;
        })
        .then((response) => {
          if (response.status == 200) {
            this.affiliates = response.data;
            this.isLoading = false;

            // this.invoicesCount = response.headers["x-up-count"]; //["Content-Length"];
          } else if (response.status == 400 || response.status == 403) {
            this.isLoading = false;
          } else {
            this.isLoading = false;
          }

        });
    },
    startDateSelected(value) {
      if (this.newGame.endDate[0] < value[0]) {
        this.dateError = true;
        this.newGame.startDate = value;
      } else {
        this.dateError = false;
        this.newGame.startDate = value;
      }
    },
    endDateSelected(value) {
      if (this.newGame.startDate[0] > value[0]) {
        this.dateError = true;
        this.newGame.endDate = value;
      } else {
        this.dateError = false;
        this.newGame.endDate = value;
      }
    },
    customLabelSubCategory({ subcategory_name }) {
      return `${subcategory_name}`;
    },
    getCategoryById(subcategory_id) {
      return this.subCategoriesSelect.filter(
        x => x.category_id === subcategory_id
      )[0];
    },
    findCategoryByName(category_name) {
      return this.categories.filter(
        x => x.category_name === category_name
      )[0];
    },
    gameImage() {
      if (this.newGame.image) {
        return "data:image/png;base64," + this.newGame.image
      } else {
        return require('@/assets/images/cms-mkt/offer_0.svg');
      }
    }
  },
  computed: {
    categoriesSelect: function () {
      let cats = [];
      this.categories.forEach((x) => {
        let cat = cats.find(
          (y) => y.category_name === x.category_name);
        if (!cat) {
          cats.push({ category_name: x.category_name, mission_type: x.mission_type });
        }
      });
      return cats;
    },
    subCategoriesSelect: function () {
      return this.categories.filter(
        x => x.category_name === this.newGame.category.category_name
      );
    },
    isGameCommercial() {
      if (this.newGame && this.newGame.type) {
        switch (this.newGame.type) {
          case "comercial":
          case "amount":
          case "counter":
            return true;
          default: return false;
        }
      }
      return false;
    },
    isGameMarketing() {
      if (this.newGame && this.newGame.type) {
        switch (this.newGame.type) {
          case "digital":
            return true;
          default:
            return false;
        }
      }
      return false;
    },
    textType() {
      switch (this.newGame.type) {
        case "daily":
          return "D";
        default:
          return "M";
      }
    },


  },
  watch: {
    game: function () {
      this.$refs.fileInput1.value = null;
      this.imageError = null;
      this.affiliatesFilter = {
        code: "",
        fiscalCode: "",
      },
      document.querySelector('input[name="categorytype"]').checked = false;
      this.previewImage = null;
      this.selectedCategory = false;
      if (this.game.group_mission) {
        this.newGame.groupMission = this.game.group_mission;
        this.newGame.id = this.game.mission_id;
      } else {
        this.newGame.groupMission = "";
        this.newGame.id = 0;
      }
      if (this.newGame.id > 0) {
        this.newGame.category = this.game.category ? this.findCategoryByName(this.game.category) : "";
        this.newGame.subcategory = this.game.category_id ? this.getCategoryById(this.game.category_id) : "";
        if (this.newGame.category != "") {
          this.selectedCategory = true;
        }

        this.newGame.endDate = this.game.end_date ? [moment(this.game.end_date, 'DD-MM-YYYY')] : [moment()];
        this.newGame.startDate = this.game.start_date ? [moment(this.game.start_date, 'DD-MM-YYYY')] : [moment()];
        this.newGame.upCoins = this.game.up_coins;
        this.newGame.groupMission = this.game.group_mission === 'Y';
        this.newGame.groupParticipants = this.game.group_participants;
        this.newGame.targetedGroupCompany = this.game.targeted_group_company;
        this.newGame.valueToComplete = this.game.value_to_complete;
        this.newGame.minTransactionValue = this.game.min_transaction_value;
        this.newGame.status = this.game.status;
        this.newGame.url = this.game.url;
        this.newGame.platform = this.game.platfrom;
        this.newGame.product = this.game.product_code;
        this.newGame.checkpoints = this.game.checkpoints;
        this.newGame.type = this.game.type;
        this.newGame.affiliates = this.game.affiliates;
        this.newGame.image = this.game.image;

        this.isAmount = this.newGame.type === 'amount';
        this.game.texts.forEach((x) => {
          this.newGame.texts[x.language] = {
            title: x.title,
            description: x.description
          }
        });
      } else {
        this.newGame = {
          texts: [],
          upCoins: 0,
          category: "",
          subcategory: 0,
          startDate: [moment()],
          endDate: [moment()],
          image: null,
          groupMission: this.game.group_mission === 'Y',
          groupParticipants: 0,
          valueToComplete: 1,
          type: "",
          url: "",
          platform: "",
          product: 11,
          affiliates: [],
          // checkpoints: []
        };
        this.newGame.texts['ro'] = { title: "", description: "" };
        this.newGame.texts['en'] = { title: "", description: "" };
      }
      // if (this.game.type === 'comercial') {
      //   this.newGame.type = 'amount';
      //   this.isAmount = true;
      // }
    },
    isAmount: function (val) {
      if (val) {
        this.newGame.type = 'amount';
      } else {
        this.newGame.type = 'counter';
      }
    },
  },
  created() {
    this.previewImage = null;
    this.newGame.groupMission = "";
    this.newGame.texts['ro'] = { title: "", description: "" };
    this.newGame.texts['en'] = { title: "", description: "" };
  },
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
<style scoped>

.position {
  position: relative;
  left: 227px;
}


.contact-details-wrapper {
  justify-content: space-evenly;
  color: #2D3736;
}

.close-button {
  right: 30px;
  top: 15px;
}

.offer-details-wrapper {
  border-radius: 48px;
  background: #E5E5E5;
  overflow-y: auto;
  height: calc(100vh - 170px) !important;
}

small {
  font-family: "Krona One";
  font-weight: 400;
  font-size: 18px;
  text-transform: uppercase;
}

.w-80 {
  width: 80%;
}

.ql-toolbar.ql-snow {
  border: 2px solid #fff !important;
  border-radius: 48px !important;
}

.multiselect {
  border: 1px solid #d8d8d8;
  background: #f1f1f1 !important;
  height: 40px !important;
  /* border-radius: 20px; */

}

.multiselect__input {
  font-size: 15px !important;
  /* border-radius: 20px !important; */
}

.multiselect__tags {
  border-radius: 40px !important;
  padding: 8px -30px 0 8px !important;
}
</style>
